var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7092 30.7131L63.4693 47.6178L73.2292 64.5225C74.003 65.8628 74.003 67.4652 73.2293 68.8055C72.4554 70.1459 71.0676 70.9471 69.52 70.9471H30.4801C28.9325 70.9471 27.5447 70.1459 26.7709 68.8056C25.997 67.4653 25.997 65.8628 26.7709 64.5225L36.5308 47.6178L46.2909 30.7131C47.0646 29.3728 48.4525 28.5715 50 28.5715C51.5477 28.5715 52.9355 29.3728 53.7092 30.7131ZM50 60.1194C51.0806 60.1194 51.9567 60.9953 51.9567 62.076C51.9567 63.1566 51.0806 64.0325 50 64.0325C48.9195 64.0325 48.0434 63.1566 48.0434 62.076C48.0434 60.9953 48.9195 60.1194 50 60.1194ZM50.001 38.5094C51.3152 38.5094 52.5078 39.5918 52.436 40.9443L51.5663 57.2929H48.6967L47.5661 40.9443C47.4738 39.6083 48.6619 38.5094 50.001 38.5094Z",
    fill: "#F0314A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F0314A",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.5095a875852485a7719a6b0afabe6d8d.svg";
export { ForwardRef as ReactComponent };